"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkTile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _common = require("b2b-components/theme/components/CMS/common");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
require("./LinkTile.scss");
const LinkTile = _ref => {
  let {
    className,
    dataAttributes,
    onClick,
    url,
    imageUrl = null,
    label = null,
    size = _common.CMS_SIZING.size100
  } = _ref;
  const handleOnClick = e => {
    e.preventDefault();
    onClick?.(url);
  };
  const rootClassName = (0, _classnames.default)('cds-cms-LinkTile', `cds-cms-LinkTile--${size}`, className);
  if (!imageUrl && !label) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName,
    href: url,
    onClick: handleOnClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-LinkTile-Wrapper"
  }, imageUrl && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-LinkTile-ImageWrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: label || undefined,
    className: "cds-cms-LinkTile-Image",
    src: imageUrl
  })), label && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-cms-LinkTile-Label"
  }, label)));
};
exports.LinkTile = LinkTile;
//# sourceMappingURL=LinkTile.js.map